Carbon('Gator')(document).on('click', '.header-interaction__element--login', function () {
    this.blur();
    document.documentElement.classList.toggle('-login--open');
});
